import { CultureListApp } from "culture/CultureListApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const cultureRoute: RouteObject = {
  path: "culture",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: CultureListApp,
  }]
};